import React, { useState, useEffect } from 'react'
import firebase from "../firebase";

import { Table } from 'react-bootstrap'


const Questions = () => {
    const [questions, setQuestions] = useState([])

    
    useEffect(()=> {
        firebase
        .firestore()
        .collection("contacts")
    .onSnapshot((snap) => {
      const newQuestions = snap.docs.map((doc)=>(
          {
              id: doc.id,
              ...doc.data()
          }))
          setQuestions(newQuestions)
    });

    }, [])

    return (
        <div>
             <Table striped bordered hover size="sm" className='mt-3'>
                <thead>
                    <tr>
                    <th>Client Name</th>                    
                    <th>client question</th>
                    </tr>
                </thead>
                  <tbody>
            {
                questions && questions.map((question, index) =>{
                    //console.log(question)
                    return(                     
                            <tr key={index}>                           
                            <td>{question.name}</td>
                            <td>{question.message}</td>                           
                            </tr>  
                    )
                })
            }
             </tbody>
             </Table>
        </div>
    )
}

export default Questions
